var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "whatsapp",
    d: "M8,0H8A8,8,0,0,0,1.523,12.689l-1,2.972L3.6,14.678A8,8,0,1,0,8,0Zm4.655,11.3a2.257,2.257,0,0,1-1.57,1.129c-.418.089-.964.16-2.8-.6A10.022,10.022,0,0,1,4.3,8.306a4.569,4.569,0,0,1-.95-2.413A2.554,2.554,0,0,1,4.17,3.946a1.162,1.162,0,0,1,.818-.287c.1,0,.188.005.268.009.235.01.353.024.508.395.193.465.663,1.613.719,1.731a.476.476,0,0,1,.034.433,1.382,1.382,0,0,1-.259.367c-.118.136-.23.24-.348.386-.108.127-.23.263-.094.5a7.1,7.1,0,0,0,1.3,1.613A5.882,5.882,0,0,0,8.99,10.248a.506.506,0,0,0,.564-.089,9.679,9.679,0,0,0,.625-.828.446.446,0,0,1,.574-.174c.216.075,1.359.64,1.594.757s.39.174.447.273A1.992,1.992,0,0,1,12.657,11.3Z",
    fill: "#e4002f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.9640f6e1fab7bd7742e743662694a85c.svg";
export { ForwardRef as ReactComponent };